/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdSwiperProps } from './type';

export const swiperDefaultProps: TdSwiperProps = {
  animation: 'slide',
  autoplay: true,
  cardScale: 210 / 332,
  defaultCurrent: 0,
  direction: 'horizontal',
  duration: 300,
  interval: 5000,
  loop: true,
  stopOnHover: true,
  trigger: 'hover',
  type: 'default',
};
